import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      const newIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(newIsMobile);
    };
    mql.addEventListener("change", onChange);
    const initialMobile = window.innerWidth < MOBILE_BREAKPOINT;
    setIsMobile(initialMobile);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
